import React, { createContext, useContext } from 'react';
import { noop } from 'lodash';
import { Attachment, AttachmentUploadProps, FileUploadContextType } from './types';
import { useAttachments } from './useAttachments';

export const FileUploadContext = createContext<FileUploadContextType>({
    rawAttachments: [] as Attachment[],
    onDropAccepted: noop,
    removeAttachment: noop,
    uploadProgress: {},
} as FileUploadContextType);

export const useUploadContext = () => {
    const context = useContext(FileUploadContext);
    if (context === undefined) {
        throw new Error('Upload components must be rendered within UploadContext');
    }
    return context;
};

export const UploadContext = (props: AttachmentUploadProps & { children: React.ReactNode }) => {
    const value = useAttachments(props);

    return <FileUploadContext.Provider value={value}>{props.children}</FileUploadContext.Provider>;
};
